import { useState, useCallback } from 'react';
import { DEFAULT_PAGE_SIZE } from '@/lib/constants';

interface UsePaginationOptions {
  initialPage?: number;
  initialLimit?: number;
}

export function usePagination(options: UsePaginationOptions = {}) {
  const [page, setPage] = useState(options.initialPage || 1);
  const [limit, setLimit] = useState(options.initialLimit || DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);

  const goToPage = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const nextPage = useCallback(() => {
    setPage((prev) => Math.min(prev + 1, totalPages));
  }, [totalPages]);

  const prevPage = useCallback(() => {
    setPage((prev) => Math.max(prev - 1, 1));
  }, []);

  const updatePagination = useCallback((data: { total_pages: number; total: number }) => {
    setTotalPages(data.total_pages);
    setTotal(data.total);
  }, []);

  const reset = useCallback(() => {
    setPage(1);
  }, []);

  return {
    page,
    limit,
    totalPages,
    total,
    goToPage,
    nextPage,
    prevPage,
    updatePagination,
    reset,
    hasNext: page < totalPages,
    hasPrev: page > 1,
  };
}
